































































import Vue from 'vue';
import Pusher from 'pusher-js';
import sleep from '~/lib/utilities/sleep';
import { ToastNotification } from '~/lib/interfaces/toastNotification';
import { mapState, mapGetters, mapMutations } from 'vuex';
import { createPusher } from '../../lib/pusher';

export default Vue.extend({
  name: 'Toast',

  data() {
    return {
      notificationShow: false,
      notificationMessage: '',
      notificationType: 'success',
      duration: 5000,
      button: {
        text: '',
        link: '',
        external: false
      }
    };
  },

  computed: {
    ...mapState('user', { userId: 'id' }),
    ...mapState('components/toast', ['notifications']),
    // If the notification button links to the current page, an anchor element
    // needs to be used instead of a NuxtLink component because vue router can't
    // reload the current page.
    onLinkedPage(): boolean {
      return this.button.link === this.$route.path;
    },

    notificationIcon() {
      switch (this.notificationType) {
        case 'success':
          return 'mdi-check-circle';
        case 'error':
          return 'mdi-alert-circle';
        case 'warning':
          return 'mdi-alert';
      }
    }
  },

  beforeDestroy() {
    this.$nuxt.$off('notify');
  },

  methods: {
    ...mapGetters('components/toast', ['getNotification']),
    ...mapMutations('components/toast', [
      'addNotification',
      'removeNotification'
    ]),

    async showClientNotification(notification: ToastNotification) {
      if (notification) {
        this.addNotification(notification);
        this.showNextNotification();
      }
    },

    async showNextNotification() {
      if (!this.notificationShow && this.notifications.length > 0) {
        const notification = this.getNotification();

        if (notification) {
          this.notificationShow = true;
          this.notificationMessage = notification.message;
          this.button = notification.button;
          this.notificationType = notification.type;
          await sleep(notification.duration ?? this.duration);
          this.notificationShow = false;
        }
        this.removeNotification();
      }
    },
    hideNotification() {
      this.removeNotification();
      this.notificationShow = false;
    },
    setUpPusher() {
      this.$nuxt.$on('notify', this.showClientNotification);
      const pusher = createPusher(
        this.$store.state.user.id,
        this.$store.state.user.clientId
      );

      const handleMessage = (notification: Partial<ToastNotification>) => {
        this.$nuxt.$emit('notify', {
          type: notification.type,
          message: notification.message,
          ...(notification.button && { button: notification.button })
        });
      };

      pusher.userChannel.bind('notifications', handleMessage);
      pusher.clientChannel.bind('notifications', handleMessage);
      pusher.globalChannel.bind(
        'refresh-notification',
        (notification: Partial<ToastNotification>) => {
          this.$nuxt.$emit('notify', {
            type: 'success',
            message: notification.message,
            duration: notification.duration,
            ...(notification.button && { button: notification.button })
          });
        }
      );
      this.showClientNotification();
    }
  },

  watch: {
    notificationShow() {
      this.showNextNotification();
    },
    notifications: 'showNextNotification',
    userId: {
      handler(id) {
        if (id) this.setUpPusher();
      },
      immediate: true
    }
  }
});
